export const superUser = {
  name: 'Mindfield',
  displayName: 'Mindfield',
  id: '18212744',
  superUser: true,
  email: 'info@mindfield-biosystems.com'
}
